/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/require-default-props */
import React from 'react';
import { Controller, Control } from 'react-hook-form';

import { VbzInputText } from '@smiles/voebiz-ui-kit';

type PropsT = {
  control: Control;
  name: string;
  error: boolean;
  textLabel: string;
  rules?: Record<string, unknown>;
  placeholder: string;
  errorMessage?: string;
  onKeyDown?: any;
  regex?: any;
  maxLength?: number;
  minLength?: number;
};

export default function ControlledInput({
  control,
  name,
  error,
  textLabel,
  rules,
  placeholder,
  errorMessage,
  onKeyDown,
  regex,
  maxLength,
  minLength,
  ...rest
}: PropsT) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ name, onChange, onBlur }) => (
        <VbzInputText
          maxLength={maxLength}
          minLength={minLength}
          name={name}
          onBlur={onBlur}
          regex={regex}
          placeholder={placeholder}
          textLabel={textLabel}
          onChange={onChange}
          forceError={Boolean(error)}
          errorMessage={errorMessage}
          onKeyDown={onKeyDown}
          {...rest}
        />
      )}
    />
  );
}
